import { Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import {
    getSitePerformanceComparison
} from '../../../Core/Service/Nicol_Common_services';

import StockReportFilters from '../UsedStockReport/usedStockReportFilters';
import { CSVLink } from "react-csv";
import GetApp from '@material-ui/icons/GetApp';
import CircularIndeterminate from '../../../Core/BudgetCore/loader';
import { GroupSalesPerformanceTable } from './groupSalesPerformance';
import BudgetFilterv2 from '../budgetFiltersv2';
import './groupSalesPerformance.scss';

const GroupSalesPerformance = () => {
    const [data, setData] = useState({
        activeHeader: "Summary",
        sites: [],
        allSites: [],
        currentCoveredBranchIds: [],
        displayGroupBenchmark: false,
        displayGroupBenchmarkButton: false,
        loadAllBranchesDetails: true,
        actionBlocked: true
    });

    const [tableLoaders, setTableLoaders] = useState({
        summaryLoader: true,
        summaryLoaderBench: true,
        newDataLoader: true,
        newDataLoaderBench: true,
        usedDataLoader: true,
        usedDataLoaderBench: true,
        newProdLoader: true,
        newProdLoaderBench: true,
        usedProdLoader: true,
        usedProdLoaderBench: true,
        financeLoader: true,
        financeLoaderBench: true,
        warrantyLoader: true,
        warrantyLoaderBench: true,
        othersLoader: true,
        othersLoaderBench: true
    });

    const [state, setState] = useState({
        includeReserved: false,
    });

    const handleincludeReserved = (event) => {
        const { name, checked } = event.target;
        setState((st) => {
            let newSt = { ...st };
            newSt[name] = checked;
            return newSt;
        });
    };

    const [selectedBranchList, setSelectedBranchList] = useState([]);

    const getSelectedBranchList = (list) => {
        setSelectedBranchList(list || []);
    };

    //Initial query or when a branch is selected or removed
    const getFilterData = async (value) => {
        var prevBranch = data.branchID || [];
        const newBranchIds = value.branchID.filter(id => !data.currentCoveredBranchIds.includes(id));
        const removedBranch = prevBranch.filter(id => !value.branchID.includes(id));
        const updateBrand = value.filterDate !== data.filterDate;
        setData((st) => ({ ...st, filterDate: value.filterDate, branchID: value.branchID, activeHeader: "Summary", actionBlocked: true }));
        setTableLoaders((st) => ({
            ...st,
            summaryLoader: true,
            summaryLoaderBench: true,
            newDataLoader: true,
            newDataLoaderBench: true,
            usedDataLoader: true,
            usedDataLoaderBench: true,
            newProdLoader: true,
            newProdLoaderBench: true,
            usedProdLoader: true,
            usedProdLoaderBench: true,
            financeLoader: true,
            financeLoaderBench: true,
            warrantyLoader: true,
            warrantyLoaderBench: true,
            othersLoader: true,
            othersLoaderBench: true
        }));

        const dataSearchTemplate = {
            filterDate: value.filterDate || [],
            franchiseCode: value.franchiseCode || [],
            branchID: value.branchID || [],
            includeReserved: state.includeReserved,
            loadAllBranchesDetails: data.loadAllBranchesDetails,
            loadSingleBranch: true,
            prodLastDataRaw: false
        };

        if (newBranchIds.length > 0 || updateBrand) {
            const dataSearch = {
                branchID: updateBrand ? value.branchID : newBranchIds,
                filterDate: value.filterDate || [],
                franchiseCode: value.franchiseCode || [],
                updateBrand: updateBrand ? true : false,
                includeReserved: state.includeReserved,
                loadAllBranchesDetails: false,
                loadBrandDetails: true,
                prodLastDataRaw: false,
            };

            getBrandGroupData(dataSearch, "Summary", "summaryLoaderBench");
        }

        if (value.branchID.length > 1) {
            // Run API calls for each branchID in parallel
            const results = await Promise.all(
                value.branchID.map(branchID => {
                    let dataSearch = {
                        ...dataSearchTemplate,
                        branchID: [branchID],
                    };
                    return getSitePerformanceComparison(dataSearch);
                })
            );

            // Merge all returned sites together
            const combinedSites = results.flatMap(res => res.data.sites);

            setData((st) => ({
                ...st,
                sites: combinedSites,
                ...(data.loadAllBranchesDetails && {
                    displayGroupBenchmarkButton: true,
                    allSitesBenchmark: results[0]?.data?.allSitesBenchmark
                }),
                loadAllBranchesDetails: false,
                actionBlocked:  false
            }));
            setTableLoaders((st) => ({
                ...st,
                summaryLoader: false
            }))
        } else if (value.branchID.length === 1) {
            // If only one branchID, make a single call

            const res = await getSitePerformanceComparison(dataSearchTemplate);

            setData((st) => ({
                ...st,
                sites: res.data.sites,
                loadAllBranchesDetails: false,
                displayGroupBenchmarkButton: true,
                allSitesBenchmark: res?.data?.allSitesBenchmark,
                actionBlocked: false
            }));
            setTableLoaders((st) => ({
                ...st,
                summaryLoader: false
            }));
        }

        if (removedBranch.length > 0) {
            var sitesUpdate = data.sites.filter(site => site.branchesSelected.every(branchID => value.branchID.includes(branchID)));
            const hasSitesWithUnselectedBranches = data.allSites.filter(site =>
                site.branchesSelected.every(branchId => !value.branchID.includes(branchId))
            );

            setTableLoaders((st) => ({
                ...st,
                summaryLoader: true,
                summaryLoaderBench: true
            }));

            var filteredBranches = data.allSites.filter(site =>
                !site.branchesSelected.some(branchId => removedBranch.includes(branchId)));
            const coveredInQuery = filteredBranches.flatMap(cq => cq.branchesSelected);

            setData((st) => ({
                ...st,
                sites: sitesUpdate,
                pageFirstLoad: false,
                ...(hasSitesWithUnselectedBranches.length > 0 && {
                    allSites: filteredBranches,
                    currentCoveredBranchIds: coveredInQuery,
                }),
                actionBlocked: false
            }));
            setTableLoaders((st) => ({
                ...st,
                summaryLoader: false,
                summaryLoaderBench: false
            }));
        }
    };

    const mergeSites = (existingSites, newSites) => {
        const siteMap = new Map();

        // Add existing sites to the map
        existingSites.forEach(site => {
            siteMap.set(site.site.trim(), { ...site });
        });

        // Merge new sites
        newSites.forEach(newSite => {
            if (newSite.site !== null) {
                const siteName = newSite.site.trim();
                if (siteMap.has(siteName)) {
                    const existingSite = siteMap.get(siteName);
    
                    // Merge numeric fields by adding them together
                    const mergedSite = { ...existingSite };
                    Object.keys(newSite).forEach(key => {
                        if (typeof newSite[key] === "number" && typeof existingSite[key] === "number") {
                            if (existingSite[key] === 0) {
                                mergedSite[key] = existingSite[key] + newSite[key];
                            }
                        } else {
                            // otherwise keep the original value (could be string, array, null etc.)
                            mergedSite[key] = existingSite[key] === "0%" ? newSite[key] : existingSite[key] ?? newSite[key];
                        }
                    });
    
                    siteMap.set(siteName, mergedSite);
                } else {
                    // New site, just add it
                    siteMap.set(siteName, { ...newSite, site: siteName }); // trim the site name
                }
            }
        });


        return Array.from(siteMap.values());
    };

    const getBrandGroupData = async (value, type, loader) => {
        const loaderType = loader;
        const updateBrand = value.updateBrand;

        value.tabType = type;

        setTableLoaders((st) => ({
            ...st,
            [loaderType]: true
        }));

        const res = await getSitePerformanceComparison(value);

        const coveredInQuery = res.data.allSites.flatMap(cq => cq.branchesSelected);

        setData((st) => ({
            ...st,
            allSites: updateBrand ? res.data.allSites : mergeSites(st.allSites, res.data.allSites),
            currentCoveredBranchIds: Array.from(new Set([...st.currentCoveredBranchIds, ...coveredInQuery])),
        }));

        setTableLoaders((st) => ({
            ...st,
            [loaderType]: false
        }));
    }

    const handleDisplayGroupBenchmark = (e) => {
        const { checked } = e.target;

        setData((st) => ({
            ...st,
            displayGroupBenchmark: checked,
        }));
        setTableLoaders((st) => ({
            ...st,
            summaryLoaderBench: true
        }));

        if (checked) {
            setData((st) => ({
                ...st,
                allSites: [...st.allSitesBenchmark, ...st.allSites],
            }));
            setTableLoaders((st) => ({
                ...st,
                summaryLoaderBench: false
            }));
        } else {
            setData((st) => ({
                ...st,
                allSites: data.allSites.filter(site =>
                    site.site !== "GROUP"),
            }));
            setTableLoaders((st) => ({
                ...st,
                summaryLoaderBench: false
            }));
        }
    }

    const loaderMaps = {
        Summary: { loader: "summaryLoader", main: "summaryLoaderBench" },
        New: { loader: "newDataLoader", main: "newDataLoaderBench" },
        Used: { loader: "usedDataLoader", main: "usedDataLoaderBench" },
        NewProducts: { loader: "newProdLoader", main: "newProdLoaderBench" },
        UsedProducts: { loader: "usedProdLoader", main: "usedProdLoaderBench" },
        Finance: { loader: "financeLoader", main: "financeLoaderBench" },
        Warranty: { loader: "warrantyLoader", main: "warrantyLoaderBench" },
        Others: { loader: "othersLoader", main: "othersLoaderBench" }
    };

    const handleTabClick = (type) => {
        const loaders = loaderMaps[type];
        const isLoaderActive = tableLoaders[loaders.loader];
        const isMainLoaderActive = tableLoaders[loaders.main];

        const canProceed = !isLoaderActive && !isMainLoaderActive;
        
        setData((st) => ({ ...st, activeHeader: type }));

        if (!canProceed) {
            handleAPICalls(loaders, type);
        }
    }

    const handleAPICalls = async (loaders, type) => {
        setTableLoaders((st) => ({
            ...st,
            [loaders.loader]: true
        }));
        setData((st) => ({
            ...st,
            displayGroupBenchmarkButton: false,
            displayGroupBenchmark: false,
            allSites: data.allSites.filter(site =>
                    site.site !== "GROUP"),
        }));

        const dataSearchBrand = {
            branchID: data.branchID,
            filterDate: data.filterDate || [],
            franchiseCode: data.franchiseCode || [],
            includeReserved: state.includeReserved,
            loadAllBranchesDetails: false,
            loadBrandDetails: true,
            prodLastDataRaw: false,
            updateBrand: false
        };

        getBrandGroupData(dataSearchBrand, type, loaders.main);

        const dataSearchTemplate = {
            filterDate: data.filterDate || [],
            franchiseCode: data.franchiseCode || [],
            branchID: data.branchID || [],
            includeReserved: state.includeReserved,
            loadAllBranchesDetails: true,
            loadSingleBranch: true,
            prodLastDataRaw: false,
            tabType: type
        };

        if (data.branchID.length > 1) {
            // Run API calls for each branchID in parallel
            const results = await Promise.all(
                data.branchID.map(branchID => {
                    let dataSearch = {
                        ...dataSearchTemplate,
                        branchID: [branchID],
                    };
                    return getSitePerformanceComparison(dataSearch);
                })
            );

            // Merge all returned sites together
            const combinedSites = results.flatMap(res => res.data.sites);

            setData((st) => ({
                ...st,
                sites: mergeSites(st.sites, combinedSites),
                ...(data.loadAllBranchesDetails && {
                    displayGroupBenchmarkButton: true,
                    allSitesBenchmark: mergeSites(st.allSitesBenchmark, results.data.allSitesBenchmark)
                }),
                loadAllBranchesDetails: false
            }));
            setTableLoaders((st) => ({
                ...st,
                [loaders.loader]: false
            }))
        } else if (data.branchID.length === 1) {
            // If only one branchID, make a single call
            const res = await getSitePerformanceComparison(dataSearchTemplate);

            setData((st) => ({
                ...st,
                sites: mergeSites(st.sites, res.data.sites),
                displayGroupBenchmarkButton: true,
                allSitesBenchmark: mergeSites(st.allSitesBenchmark, res.data.allSitesBenchmark)
            }));
            setTableLoaders((st) => ({
                ...st,
                [loaders.loader]: false
            }));
        }
    }

    const summaryCSV = [
        {
        key: "site",
        label: "Site",
        },
        {
            key: "newVol",
            label: "New Vol",
        },
        {
            label: "New Profit",
            key: "newProfit",
        },
        {
            label: "Avg.New PPU",
            key: "avgNewPPU",
        },
        {
            key: "newPPS",
            label: "New PPS",
        },
        {
            key: "usedVol",
            label: "Used Vol",
        },
        {
            key: "usedProfit",
            label: "Used Profit",
        },
        {
            key: "avgUsedPPU",
            label: "Avg.Used PPU",
        },
        {
            key: "usedPPS",
            label: "Used PPS",
        }
    ];

    const newCSV = [
        {
            key: "site",
            label: "Site",
        },
        {
            key: "newVol",
            label: "Total Vol",
        },
        {
            key: "newRetail",
            label: "Retail",
        },
        {
            key: "newMotability",
            label: "Motability",
        },
        {
            key: "newFleet",
            label: "Fleet",
        },
        {
            key: "avgNewPPU",
            label: "Avg.Retail PPU",
        },
        {
            key: "newFinance",
            label: "Retail Fin Vol",
        },
        {
            key: "newFinancePercent",
            label: "Finance Pen",
        },
        {
            key: "newFinanceCommission",
            label: "Finance Commission",
        }
    ];

    const usedCSV = [
        {
            key: "site",
            label: "Site",
        },
        {
            key: "usedVol",
            label: "Total Vol",
        },
        {
            key: "usedRetail",
            label: "Retail",
        },
        {
            key: "avgUsedPPU",
            label: "Avg.Retail PPU",
        },
        {
            key: "usedMechPrep",
            label: "Mech Prep",
        },
        {
            key: "usedBodyWork",
            label: "Bodywork",
        },
        {
            key: "usedFinance",
            label: "Retail Fin Vol",
        },
        {
            key: "usedFinancePercent",
            label: "Finance Pen",
        },
        {
            key: "usedFinanceCommission",
            label: "Finance Commission",
        },
        {
            key: "usedTrade",
            label: "Trade",
        },
        {
            key: "usedTradePPU",
            label: "Trade PPU",
        },
    ];

    const newProdCSV = [
        {
            key: "site",
            label: "Site",
        },
        {
            key: "newPPS",
            label: "PPS",
        },
        {
            key: "newProductProfit",
            label: "Product Profit",
        },
        {
            key: "newProductPen",
            label: "Product Pen",
        },
        {
            key: "newSupagard",
            label: "Supagard",
        },
        {
            key: "newServicePlan",
            label: "Service Plan",
        },
        {
            key: "newTyreAndAlloy",
            label: "Tyre and Alloy",
        },
        {
            key: "newCosmetic",
            label: "Cosmetic",
        }
    ];

    const usedProdCSV = [
        {
            key: "site",
            label: "Site",
        },
        {
            key: "usedPPS",
            label: "PPS",
        },
        {
            key: "usedProductProfit",
            label: "Product Profit",
        },
        {
            key: "usedProductPen",
            label: "Product Pen",
        },
        {
            key: "usedSupagard",
            label: "Supagard",
        },
        {
            key: "usedServicePlan",
            label: "Service Plan",
        },
        {
            key: "usedTyreAndAlloy",
            label: "Tyre and Alloy",
        },
        {
            key: "usedCosmetic",
            label: "Cosmetic",
        },
    ];

    const finCSV = [
        {
            key: "site",
            label: "Site",
        },
        {
            key: "newFinance",
            label: "Cases(N)",
        },
        {
            key: "newFinancePercent",
            label: "Retail Pen(N)",
        },
        {
            key: "newFinanceVol",
            label: "Total Volume(N)",
        },
        {
            key: "newFinanceCommission",
            label: "Commission(N)",
        },
        {
            key: "usedFinance",
            label: "Cases(U)",
        },
        {
            key: "usedFinancePercent",
            label: "Retail Pen(U)",
        },
        {
            key: "usedFinanceVol",
            label: "Total Volume(U)",
        },
        {
            key: "usedFinanceCommission",
            label: "Commission(U)",
        }
    ];

    const warrantyCSV = [
        {
            key: "site",
            label: "Site",
        },
        {
            key: "warrantyVol",
            label: "Volume",
        },
        {
            key: "warrantyProfit",
            label: "Warranty Profit",
        },
        {
            key: "warrantyPen",
            label: "Warrant Pen",
        },
        {
            key: "ccPremium",
            label: "CC Premium",
        },
        {
            key: "ccPremiumPlus",
            label: "CC Premium +",
        },
        {
            key: "nicEx",
            label: "NIC Extended",
        },
        {
            key: "missedUpsell",
            label: "Missed Upsell",
        }
    ];

    const othersCSV = [
        {
            key: "site",
            label: "Site",
        },
        {
            key: "newAccProfit",
            label: "Acc. Profit(N)",
        },
        {
            key: "newDeliveryPack",
            label: "Delivery Pack(N)",
        },
        {
            key: "newIncorrectAdmin",
            label: "Incorrect Admin(N)",
        },
        {
            key: "newIncorrectFuel",
            label: "Incorrect Fuel(N)",
        },
        {
            key: "usedAccProfit",
            label: "Acc. Profit(U)",
        },
        {
            key: "usedDeliveryPack",
            label: "Delivery Pack(U)",
        },
        {
            key: "usedIncorrectAdmin",
            label: "Incorrect Admin(U)",
        },
        {
            key: "usedIncorrectFuel",
            label: "Incorrect Fuel(U)",
        },
        {
            key: "tradeIncorrectAdmin",
            label: "Incorrect Admin(T)",
        },
    ];

    return (
        <div className="boxSkel">
            <Grid container spacing={1} alignContent="center" justifyContent="space-between">
                <Grid item xs style={{ textAlign: 'left' }}>
                    <div className="titleBoxSkel">
                        Group Sales Performance

                        <FormControlLabel
                            control={<Switch checked={state.includeReserved} onChange={handleincludeReserved} name="includeReserved" />}
                            label="Include Reserved"
                            labelPlacement="start"
                        />
                    </div>
                </Grid>
            </Grid>

            <BudgetFilterv2 getFilterData={getFilterData} getSelectedBranchList={getSelectedBranchList} includeReserved={state.includeReserved} hideFranchiseSearch={true} />

            <div className='exportCSVButtonWrp'>
                <div className='exportCSVButtonGroup'>
                    <CSVLink data={[...data.allSites, ...data.sites]} headers={
                        data.activeHeader === "Summary" ? summaryCSV :
                        data.activeHeader === "New" ? newCSV :
                        data.activeHeader === "Used" ? usedCSV :
                        data.activeHeader === "NewProducts" ? newProdCSV :
                        data.activeHeader === "UsedProducts" ? usedProdCSV :
                        data.activeHeader === "Finance" ? finCSV :
                        data.activeHeader === "Warranty" ? warrantyCSV :
                        data.activeHeader === "Others" ? othersCSV : ""
                    } target="_blank" filename={``+data.activeHeader+`-GroupSalesPerformance.csv`}>
                        DOWNLOAD CSV
                        <GetApp />
                    </CSVLink>
                </div>
                <div className="toggleGroupButton">
                    {
                        data.displayGroupBenchmarkButton ? <>
                            <FormControlLabel
                                control={<Switch checked={data.displayGroupBenchmark} onChange={handleDisplayGroupBenchmark} name="displayGroupBenchmark" />}
                                label="Group Benchmark"
                                labelPlacement="start"
                            />
                        </> : <></>
                    }
                </div>
            </div>

            <div className='groupHeaders'>
                <div className={data.activeHeader === "Summary" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span style={ data.actionBlocked ? {pointerEvents: "none"} : {pointerEvents: "auto"} } onClick={() => handleTabClick("Summary")}>Summary</span>
                </div>
                <div className={data.activeHeader === "New" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span style={ data.actionBlocked ? {pointerEvents: "none"} : {pointerEvents: "auto"} } onClick={() => handleTabClick("New")}>New</span>
                </div>
                <div className={data.activeHeader === "Used" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span style={ data.actionBlocked ? {pointerEvents: "none"} : {pointerEvents: "auto"} } onClick={() => handleTabClick("Used")}>Used</span>
                </div>
                <div className={data.activeHeader === "NewProducts" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span style={ data.actionBlocked ? {pointerEvents: "none"} : {pointerEvents: "auto"} } onClick={() => handleTabClick("NewProducts")}>New Products</span>
                </div>
                <div className={data.activeHeader === "UsedProducts" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span style={ data.actionBlocked ? {pointerEvents: "none"} : {pointerEvents: "auto"} } onClick={() => handleTabClick("UsedProducts")}>Used Products</span>
                </div>
                <div className={data.activeHeader === "Finance" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span style={ data.actionBlocked ? {pointerEvents: "none"} : {pointerEvents: "auto"} } onClick={() => handleTabClick("Finance")}>Finance</span>
                </div>
                <div className={data.activeHeader === "Warranty" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span style={ data.actionBlocked ? {pointerEvents: "none"} : {pointerEvents: "auto"} } onClick={() => handleTabClick("Warranty")}>Warranty</span>
                </div>
                <div className={data.activeHeader === "Others" ? "groupHeadersItem active" : "groupHeadersItem"}>
                    <span style={ data.actionBlocked ? {pointerEvents: "none"} : {pointerEvents: "auto"} } onClick={() => handleTabClick("Others")}>Others</span>
                </div>
            </div>
            <div className='groupTiles'>
                <div className={'groupTileWrp active'}>
                    <div className="groupTile top">
                        <span>BENCHMARK AVERAGES</span>
                        {
                            (data.activeHeader === "Summary" && tableLoaders.summaryLoaderBench) ||
                                (data.activeHeader === "New" && tableLoaders.newDataLoaderBench) ||
                                (data.activeHeader === "Used" && tableLoaders.usedDataLoaderBench) ||
                                (data.activeHeader === "NewProducts" && tableLoaders.newProdLoaderBench) ||
                                (data.activeHeader === "UsedProducts" && tableLoaders.usedProdLoaderBench) ||
                                (data.activeHeader === "Finance" && tableLoaders.financeLoaderBench) ||
                                (data.activeHeader === "Warranty" && tableLoaders.warrantyLoaderBench) ||
                                (data.activeHeader === "Others" && tableLoaders.othersLoaderBench) ?
                                (
                                    <CircularIndeterminate type="small" />
                                ) : (
                                    <GroupSalesPerformanceTable type={data.activeHeader} sites={data.allSites} />
                                )
                        }
                    </div>
                    <div className="groupTile">
                        <span>SITE COMPARISONS</span>
                        {
                            (data.activeHeader === "Summary" && tableLoaders.summaryLoader) ||
                                (data.activeHeader === "New" && tableLoaders.newDataLoader) ||
                                (data.activeHeader === "Used" && tableLoaders.usedDataLoader) ||
                                (data.activeHeader === "NewProducts" && tableLoaders.newProdLoader) ||
                                (data.activeHeader === "UsedProducts" && tableLoaders.usedProdLoader) ||
                                (data.activeHeader === "Finance" && tableLoaders.financeLoader) ||
                                (data.activeHeader === "Warranty" && tableLoaders.warrantyLoader) ||
                                (data.activeHeader === "Others" && tableLoaders.othersLoader) ?
                                (
                                    <CircularIndeterminate type="small" />
                                ) : (
                                    <GroupSalesPerformanceTable type={data.activeHeader} sites={data.sites} />
                                )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GroupSalesPerformance;
